import firebase from 'firebase/app'
import 'firebase/storage'

export class CloudStorageHandler {
    addFile(imageName, dataUrl){
        return new Promise( (resolve) => {
            const storageRef = firebase.storage().ref();
        // write new image to storage (from string)
            storageRef.child(imageName).putString(dataUrl, 'data_url')
                .then( () => {
                // get image url
                    storageRef.child(imageName).getDownloadURL()
                        .then( (url) => {
                            resolve(url);
                        })
                        .catch((error)=> {
                            console.log("Error getting image url:", error);
                            resolve(null);
                        });
                })
                .catch((error)=> {
                    console.log("Error uploading image:", error);
                    resolve(null);
                });
        })
    }

    addImageFromFile(imageName, file){
        return new Promise( (resolve) => {
            const storageRef = firebase.storage().ref();
        // write new image to storage (from string)
            storageRef.child(imageName).put(file)
                .then( () => {
                // get image url
                    storageRef.child(imageName).getDownloadURL()
                        .then( (url) => {
                            resolve(url);
                        })
                        .catch((error)=> {
                            console.log("Error getting image url:", error);
                            resolve(null);
                        });
                })
                .catch((error)=> {
                    console.log("Error uploading image:", error);
                    resolve(null);
                });
        })
    }

    deleteFile(fileName){
            console.log ("CloudStorageHandler: ", fileName);
        // define storage
            const storageRef = firebase.storage().ref();
            const fileRef = storageRef.child(fileName);
        // Delete the file
            fileRef.delete().then(() => {
                // File deleted successfully
            }).catch((error) => {
                // Uh-oh, an error occurred!
                console.log ("error: ", error);
            });
    }
}